import axios from "axios";
import qs from "qs";
import { BASE_API } from "./constant.js";

// 创建 axios 实例
console.log("process.env.VUE_APP_BASE_API", process.env.VUE_APP_BASE_API);
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || BASE_API, // 可根据环境设置 base URL
  // baseURL: BASE_API, // 可根据环境设置 base URL
  timeout: 50000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 设置 token
    const token = localStorage.getItem("token");
    config.headers["Authorization"] = token || "";

    // 默认 Content-Type
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json;charset=utf-8";
    }

    // GET 请求参数序列化（可选）
    // if (config.method.toUpperCase() === "GET" && config.params) {
    //   config.url += "?" + qs.stringify(config.params, { indices: false });
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器在 api.js 中统一处理更合适（便于控制 callback）
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js